import { Component, OnInit } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AdminQuestion, Category } from '../../models/questions';


@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html'
})
export class QuestionListComponent implements OnInit {
  isAddQuestionForm = false;
  questions: Array<AdminQuestion>;
  categoryName: string;
  selectedCategoryId: number;
  searchText = '';
  
  constructor(private questionService: QuestionService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap
      .subscribe((params: ParamMap) => {
        this.selectedCategoryId = (params.get('id')) ? +params.get('id') : this.selectedCategoryId;
        this.getQuestionsByCatagery();
      });
  }

  getCategoryQuestions(category: Category) {
    this.categoryName = category.name;
    if (!this.selectedCategoryId) {
      this.selectedCategoryId = category.id;
      this.getQuestionsByCatagery();
    }
  }

  addQuestion() {
    this.isAddQuestionForm = true;
  }

  closeOnSave(data: AdminQuestion) {
    this.getQuestionsByCatagery();
    this.isAddQuestionForm = false;
  }

  deleteQuestion(questionId: number) {
    const index = this.questions.findIndex(q => q.id === questionId);
    if (index === -1) {
      return;
    } else {
      this.questions.splice(index, 1);
    }
  }

  cloneQuestion(question: AdminQuestion) {
    this.questions.push(question);
    this.getQuestionsByCatagery();
  }

  hideForm() {
    this.isAddQuestionForm = false;
  }

  private getQuestionsByCatagery() {
    this.questionService.getByCategoryId(this.selectedCategoryId)
    .subscribe(q => this.questions = q);
  }
}
